package ir.site.zero1plus.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.FaShip
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.LinkStyle
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.extendedBy
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import ir.site.zero1plus.components.sections.LogoBrand
import ir.site.zero1plus.components.sections.LogoBrandStyle
import ir.site.zero1plus.components.sections.NavBarItemStyle
import ir.site.zero1plus.helper.colorModeDetect
import ir.site.zero1plus.model.NavBarMenu
import ir.site.zero1plus.theme.PrimaryDark
import ir.site.zero1plus.theme.PrimaryLight
import ir.site.zero1plus.theme.TextPrimaryDark
import ir.site.zero1plus.theme.TextPrimaryLight
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Text

val OverFlowMenuStyle = SmoothColorStyle.extendedBy {
    base {
        Modifier
            .fillMaxWidth()
            .height(100.vh)
            .position(Position.Fixed)
            .zIndex(3)
    }
}

val OverFlowMenuItemsStyle = CssStyle {
    base {
        Modifier
            .cursor(Cursor.Pointer)
            .textDecorationLine(TextDecorationLine.None)
            .color(TextPrimaryLight)
            .transition(Transition.of("color", 300.ms))

    }
    hover {
        Modifier.color(colorModeDetect( darkMode = PrimaryDark , lightMode =  PrimaryLight))
    }
}

@Composable
fun OverFlowMenu(
    onMenuClosed: () -> Unit
) {

    val breakpoint = rememberBreakpoint()
    var translateX by remember { mutableStateOf(100.percent) }
    var opacity by remember { mutableStateOf(0.percent) }
    val coroutineScope = rememberCoroutineScope()
    val animationTime: Long = 350


    LaunchedEffect(breakpoint) {
        translateX = 0.percent
        opacity = 50.percent
        if (breakpoint > Breakpoint.SM) {
            translateX = 100.percent
            opacity = 0.percent
            delay(animationTime)
            onMenuClosed()
        }
    }


    Row(modifier = OverFlowMenuStyle.toModifier()) {
        Column(
            modifier = Modifier
                .fillMaxHeight()
                .width(
                    if (breakpoint < Breakpoint.MD) 50.percent
                    else 35.percent
                )
                .overflow(Overflow.Auto)
                .scrollBehavior(ScrollBehavior.Smooth)
                .backgroundColor(Colors.White)
                .translateX(tx = translateX)
                .transition(Transition.of(property = "translate", duration = animationTime.ms))
                .padding(16.px)
        ) {
            Column (
                modifier = Modifier.fillMaxWidth()
                    .margin(top = 10.px),
                verticalArrangement = Arrangement.spacedBy(20.px),
                horizontalAlignment = Alignment.Start
            ){
                FaXmark(
                    modifier = Modifier
                        .color(Colors.Black)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            coroutineScope.launch {
                                translateX = 100.percent
                                opacity = 0.percent
                                delay(animationTime)
                                onMenuClosed()
                            }
                        },
                    size = IconSize.XL,
                )
                NavBarMenu.values().forEach {
                    Link(
                        modifier = OverFlowMenuItemsStyle.toModifier()
                            .onClick {
                                coroutineScope.launch {
                                    translateX = 100.percent
                                    opacity = 0.percent
                                    delay(animationTime)
                                    onMenuClosed()
                                }
                            },
                        path = it.path,
                    ){
                        Text(it.title)
                    }
                }
            }

        }
        Box(
            modifier = Modifier
                .fillMaxHeight()
                .width(
                    if (breakpoint < Breakpoint.SM) 50.percent
                    else 65.percent
                )
                .backgroundColor(Colors.Black)
                .opacity(opacity)
                .transition(Transition.of(property = "opacity", duration = animationTime.ms))
                .onClick {
                    coroutineScope.launch {
                        translateX = 100.percent
                        opacity = 0.percent
                        delay(animationTime)
                        onMenuClosed()
                    }
                }
        )
    }

}